/**
 * POTENT POTIONS — Luxury Botanical Theme Interactions Script
 * Built with Vanilla JavaScript ES6 for maximum performance, 0 dependencies.
 */

document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initScrollAnimations();
  initCartDrawer();
  initAjaxCart();
  initQuickView();
  initAccordions();
  initIngredientCards();
  initParallaxEffects();
  initSearchPopup();
});

/* 1. Header Scroll Logic */
function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 40) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/* 2. Reveal on Scroll Observer */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.reveal-on-scroll');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, { threshold: 0.15 });

  elements.forEach(el => observer.observe(el));
}

/* 3. Cart Drawer */
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('DrawerOverlay');

  if (!drawer || !overlay) return;

  const openDrawer = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  // Delegated so re-rendered drawer content keeps working after AJAX updates
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-cart"]')) openDrawer(e);
    else if (e.target.closest('[data-action="close-cart"]')) closeDrawer();
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  window.PotentPotions = window.PotentPotions || {};
  window.PotentPotions.openCart = openDrawer;
  window.PotentPotions.closeCart = closeDrawer;
}

/* 4. Quick View Modal */
function initQuickView() {
  const modal = document.getElementById('QuickViewModal');
  const overlay = document.getElementById('DrawerOverlay');
  const quickViewBtns = document.querySelectorAll('[data-action="quick-view"]');

  if (!modal) return;

  const qvAddBtn = modal.querySelector('#QuickViewAdd');
  const qvLink = modal.querySelector('#QuickViewLink');

  quickViewBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const productTitle = btn.getAttribute('data-product-title') || 'Luxury Botanical Elixir';
      const productPrice = btn.getAttribute('data-product-price') || '₹1,850';
      const productImage = btn.getAttribute('data-product-image');
      const productSub = btn.getAttribute('data-product-sub') || 'Pure Organic Extract';
      const productIngr = btn.getAttribute('data-product-ingr') || 'Kashmiri Saffron, Sandalwood, Kumkumadi Oil';
      const productUrl = btn.getAttribute('data-product-url') || '#';
      const variantId = btn.getAttribute('data-variant-id') || '';
      const available = btn.getAttribute('data-available') !== 'false';

      modal.querySelector('.qv-title').textContent = productTitle;
      modal.querySelector('.qv-price').textContent = productPrice;
      modal.querySelector('.qv-sub').textContent = productSub;
      modal.querySelector('.qv-ingredients').textContent = productIngr;
      if (productImage) {
        modal.querySelector('.qv-image').src = productImage;
      }
      if (qvLink) qvLink.href = productUrl;
      if (qvAddBtn) {
        qvAddBtn.dataset.variantId = variantId;
        qvAddBtn.disabled = !available || !variantId;
        qvAddBtn.querySelector('span').textContent = available ? 'Add to Ritual Cart' : 'Sold Out';
      }

      modal.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  if (qvAddBtn) {
    qvAddBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = qvAddBtn.dataset.variantId;
      if (!variantId) return;
      // Close the quick view, then add so the cart drawer is the focus
      modal.classList.remove('active');
      if (window.PotentPotions && window.PotentPotions.addVariant) {
        window.PotentPotions.addVariant(variantId, 1, qvAddBtn);
      }
    });
  }

  const closeBtn = modal.querySelector('[data-action="close-qv"]');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
}

/* 5. Accordion Components */
function initAccordions() {
  const accordions = document.querySelectorAll('.accordion-header');
  accordions.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const content = item.querySelector('.accordion-content');
      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.accordion-item.open').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('open');
          openItem.querySelector('.accordion-content').style.maxHeight = null;
        }
      });

      if (isOpen) {
        item.classList.remove('open');
        content.style.maxHeight = null;
      } else {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* 6. Ingredient Experience Interactive Cards */
function initIngredientCards() {
  const cards = document.querySelectorAll('.ingredient-card');
  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      cards.forEach(c => c.classList.remove('featured'));
      card.classList.add('featured');
    });
  });
}

/* 7. Parallax Effects */
function initParallaxEffects() {
  const parallaxBg = document.querySelector('.hero-parallax-bg');
  if (!parallaxBg) return;

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    parallaxBg.style.transform = `translateY(${scrolled * 0.25}px)`;
  }, { passive: true });
}

/* 8. Search Popup */
function initSearchPopup() {
  const popup = document.getElementById('SearchPopup');
  const trigger = document.querySelectorAll('[data-action="open-search"]');
  const close = document.querySelectorAll('[data-action="close-search"]');

  if (!popup) return;

  trigger.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    popup.classList.add('active');
    document.querySelector('.search-popup-input')?.focus();
  }));

  close.forEach(btn => btn.addEventListener('click', () => {
    popup.classList.remove('active');
  }));
}

/* 9. AJAX Cart — add / update / remove without page reload */
function initAjaxCart() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  window.PotentPotions = window.PotentPotions || {};
  window.PotentPotions.addVariant = (id, qty, btn) => submitAdd(id, qty || 1, btn);

  // Intercept add-to-cart submits (product cards, product page, mobile bar)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const isCardForm = form.matches('[data-product-card-form]');
    const isProductForm = form.id === 'product-form';
    if (!isCardForm && !isProductForm) return;

    // On the product page, let "Buy Now" (name="checkout") post normally
    if (isProductForm && e.submitter && e.submitter.name === 'checkout') return;

    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    e.preventDefault();
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    const btn = e.submitter || form.querySelector('[type="submit"]');
    submitAdd(idInput.value, qty, btn);
  });

  // Quantity +/- and remove inside the drawer (event delegation survives re-render)
  drawer.addEventListener('click', (e) => {
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;
    const key = item.getAttribute('data-key');
    const qtyEl = item.querySelector('[data-qty]');
    const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

    if (e.target.closest('[data-cart-plus]')) {
      changeCart(key, current + 1);
    } else if (e.target.closest('[data-cart-minus]')) {
      changeCart(key, current - 1);
    } else if (e.target.closest('[data-cart-remove]')) {
      changeCart(key, 0);
    }
  });
}

function submitAdd(variantId, quantity, btn) {
  const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  if (btn) btn.classList.add('is-loading');

  fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  })
    .then(res => res.json().then(data => ({ ok: res.ok, data })))
    .then(({ ok, data }) => {
      if (!ok || data.status) {
        flashButton(btn, data.description || 'Unavailable', true);
        return;
      }
      if (data.sections && data.sections['cart-drawer']) {
        replaceDrawer(data.sections['cart-drawer']);
        syncCountFromDrawer();
        if (window.PotentPotions.openCart) window.PotentPotions.openCart();
      } else {
        refreshDrawer(true);
      }
      flashButton(btn, 'Added ✓', false);
    })
    .catch(() => flashButton(btn, 'Try again', true));
}

/* Fallback: fetch the cart drawer section directly, then optionally open it */
function refreshDrawer(open) {
  fetch('?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
    .then(res => res.json())
    .then(data => {
      if (data && data['cart-drawer']) {
        replaceDrawer(data['cart-drawer']);
        syncCountFromDrawer();
        if (open && window.PotentPotions.openCart) window.PotentPotions.openCart();
      }
    })
    .catch(() => {});
}

function changeCart(key, quantity) {
  const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
  const drawer = document.getElementById('CartDrawer');
  if (drawer) drawer.classList.add('is-loading');

  fetch(changeUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: key,
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  })
    .then(res => res.json())
    .then(data => {
      if (data.sections && data.sections['cart-drawer']) {
        replaceDrawer(data.sections['cart-drawer']);
      }
      if (typeof data.item_count === 'number') {
        updateCartCount(data.item_count);
      } else {
        syncCountFromDrawer();
      }
    })
    .finally(() => {
      const d = document.getElementById('CartDrawer');
      if (d) d.classList.remove('is-loading');
    });
}

/* Replace drawer inner HTML while preserving the outer element + open state */
function replaceDrawer(html) {
  const current = document.getElementById('CartDrawer');
  if (!current) return;
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  const fresh = tmp.querySelector('#CartDrawer');
  current.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
}

/* Read the authoritative item count from the freshly rendered drawer */
function syncCountFromDrawer() {
  const label = document.querySelector('#CartDrawer [data-cart-count-label]');
  if (!label) return;
  const match = label.textContent.match(/\d+/);
  updateCartCount(match ? parseInt(match[0], 10) : 0);
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function flashButton(btn, message, isError) {
  if (!btn) return;
  btn.classList.remove('is-loading');
  const span = btn.querySelector('span') || btn;
  const original = btn.dataset.originalLabel || span.textContent;
  btn.dataset.originalLabel = original;
  span.textContent = message;
  if (!isError) btn.classList.add('is-added');
  setTimeout(() => {
    span.textContent = original;
    btn.classList.remove('is-added');
  }, 1600);
}
